export default __webpack_public_path__ + "static/media/solteiroduplo_3.90f58bdf.jpg";